module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAiklEQVQ4T63UwQ2AIAwF0HYDrzqKXhjBDYwTuIojMAonRtExajiQmIjtr5F7Hy39gcl5zjBFIemGlOd7KXucghDTQiJrn3L8BGlIAaGOLASCEMSEUESFPMgr5EWa0BHGnZm31oq1qDy29htUbv1ltNq+F1MD6cHMZKOYCaFvBkEIBkMW5oIq1vrYLl+pfBOSVu1vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/lawColumn/backiconr.png
// module id = Ith2
// module chunks = 0